import { jsx as _jsx } from "react/jsx-runtime";
import { Button as ChakraButton, forwardRef, } from '@chakra-ui/react';
import { Spinner } from '../Spinner';
export const Button = forwardRef(({ children, spinnerFontSize, isFullWidth, ...props }, ref) => {
    return (_jsx(ChakraButton, { ref: ref, spinner: _jsx(Spinner, { fontSize: spinnerFontSize ?? '1.5rem' }), ...props, ...(isFullWidth ? { w: '100%', p: '15px', h: 'auto' } : {}), children: children }));
});
Button.displayName = 'Button';
